interface PerformableTask {
  perform(): Promise<unknown>;
}

/**
 * Perform a lenient save task, then rethrow the failure it recorded (#9715).
 *
 * The TAS wizard `saveTask`s deliberately swallow errors (recording them in a
 * tracked `saveError`) so standalone Save buttons stay lenient. Submit paths
 * must NOT be lenient: proceeding to the state transition after a failed save
 * submits the application with stale, previously-persisted totals — the
 * mechanism behind the CourseCa$h over-authorization (tuitionio/tio-api#8972).
 * Every wizard submit path routes its pre-transition save through this helper
 * so a recorded failure aborts the submission.
 */
export async function performGuardedSave(
  saveTask: PerformableTask,
  getSaveError: () => unknown
): Promise<void> {
  await saveTask.perform();
  const error = getSaveError();
  if (error) {
    throw error;
  }
}
